import carPurchase from './car-purchase';
import carSource from './car-source.ts';
import company from './company';
import contacts from './contacts';
import document from './document';
import domesticTrade from './domestic-trade';
import exportBusiness from './export-business';
import exportLicense from './export-license';
import exportProject from './export-project';
import financialReconciliation from './financial-reconciliation';
import foreignTrade from './foreign-trade';
import globalSearch from './global-search.ts';
import helpCenter from './help-center';
import inventory from './inventory';
import logistics from './logistics';
import myTodo from './my-todo';
import payment from './payment';
import platform from './platform';
import system from './system';
import type { Menu } from './types';

export const allMenus: Menu[] = [
  ...myTodo,
  ...exportProject,
  ...carPurchase,
  ...domesticTrade,
  ...foreignTrade,
  ...logistics,
  ...inventory,
  ...document,
  ...exportLicense,
  ...exportBusiness,
  ...payment,
  ...financialReconciliation,
  ...company,
  ...carSource,
  ...globalSearch,
  ...contacts,
  ...helpCenter,
  ...system,
  ...platform,
];
